// The values here match the values that we currently use when
// exporting a file so they might be subject to change.
export const csvFieldsMap = {
  de: {
    uuid: 'Eindeutige ID',
    name: 'Name',
    lat: 'Breitengrad',
    lng: 'Längengrad',
    street_name: 'Straße',
    street_number: 'Hausnummer',
    zip_code: 'PLZ',
    city: 'Stadt',
    state: 'Bundesland',
    project_uuid: 'Projekt UUID',
    group_uuid: 'Gruppe UUID',
    company_uuid: 'Unternehmen UUID',
    empty_template_reference_date: 'Template Referenzdatum',
    empty_template_repeat_interval: 'Template Wiederholungsintervall',
    empty_template_repeat_type: 'Template Wiederholungstyp',
    empty_template_route_position: 'Template Tourposition',
    fraction_avv_number: 'Fraktion',
    type_volume: 'Volumen (in cbm)',
    type_name: 'Behältertypname',
    type_container_type_group_name: 'Behältertypgruppe',
    internal_id: 'Interne ID',
    type_manufacturer_name: 'Hersteller',
    identifier_type: 'Identifier Typ',
    identifier_name: 'Identifier Name',
    identifier_value: 'Identifier Wert',
  },
  en: {
    uuid: 'Unique ID',
    name: 'Name',
    lat: 'Latitude',
    lng: 'Longitude',
    street_name: 'Street Name',
    street_number: 'Street Number',
    zip_code: 'ZIP Code',
    city: 'City',
    state: 'State',
    project_uuid: 'Project UUID',
    group_uuid: 'Group UUID',
    company_uuid: 'Company UUID',
    empty_template_reference_date: 'Template Reference Date',
    empty_template_repeat_interval: 'Template Repeat Interval',
    empty_template_repeat_type: 'Template Repeat Type',
    empty_template_route_position: 'Template Route Position',
    fraction_avv_number: 'Fraction',
    type_volume: 'Volume (in cbm)',
    type_name: 'Container Type Name',
    type_container_type_group_name: 'Container Type Group Name',
    internal_id: 'Internal ID',
    type_manufacturer_name: 'Manufacturer',
    identifier_type: 'Identifier Type',
    identifier_name: 'Identifier Name',
    identifier_value: 'Identifier Value',
  },
}

export const requiredFields = {
  de: [
    'Eindeutige ID',
    'Name',
    'Breitengrad',
    'Längengrad',
    'Projekt UUID',
    'Unternehmen UUID',
    'Volumen (in cbm)',
    'Behältertypname',
  ],
  en: [
    'Unique ID',
    'Name',
    'Latitude',
    'Longitude',
    'Project UUID',
    'Company UUID',
    'Volume (in cbm)',
    'Container Type Name',
  ],
}
